<div class="container content-terms">
    <div class="content-wp-page" [innerHTML]="contentPage"></div>
</div>